import { defineStore } from "pinia";
import api from "@/_helpers/api";
import { axiosInstance } from "@/plugins/https";
import { StoreModule } from "@/constants/store.ts";

export interface CloudAppsSettings {
  inactiveDays: number | null;
  excludedIpAddresses: string[];
  automaticIpExclusionEnabled: boolean;
}

export interface CloudAppsSettingsState {
  settings: CloudAppsSettings;
  isLoading: boolean;
  showSkeletonLoader: boolean;
}

export const useCloudAppsSettingsStore = defineStore(StoreModule.CLOUD_APPS_SETTINGS, {
  state: (): CloudAppsSettingsState => ({
    settings: {
      inactiveDays: null,
      excludedIpAddresses: [],
      automaticIpExclusionEnabled: false,
    },
    isLoading: false,
    showSkeletonLoader: false,
  }),
  actions: {
    async getSettings(showSkeletonLoader = true) {
      this.showSkeletonLoader = showSkeletonLoader;

      const request = api.cloudSecuritySettings();

      try {
        const { data } = await axiosInstance.request(request);

        this.settings = {
          ...data,
        };
      } catch (error) {
        console.error(error);
      }
      this.showSkeletonLoader = false;
    },
    async updateSetting(data: Partial<CloudAppsSettings>) {
      this.isLoading = true;

      const request = {
        ...api.cloudSecuritySettings(),
        data,
        method: "PUT",
      };

      try {
        await axiosInstance.request(request);

        this.getSettings(false);
      } catch (error) {
        console.error(error);
      }

      this.isLoading = false;
    },
  },
});
